import { useMemo } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import { ProjectId } from 'api/models';
import { RootState } from 'data';
import { Task } from 'data/tasks';
import { useProjectTasksQuery } from 'queries/task';
import { selectTasksByProjectId, getTasksByProjectId } from '../selectors';

/**
 *
 * @deprecated Use `TasksStore.ofProjectId`
 */
export const useTasksFromStore = ([, projectId]: ProjectId): Task[] => {
  const tasks = useSelector(
    selectTasksByProjectId(ProjectId(projectId)),
    shallowEqual,
  );

  return tasks;
};

export const useTasksFromStoreRQ = (projectId: ProjectId): Task[] => {
  const { data: _tasks } = useProjectTasksQuery(projectId);
  const tasks = useMemo(
    () =>
      _tasks?.map(
        (e) =>
          ({
            ...e,
            project: e?.project?.projectId,
            subTasks: e?.subTasks?.map((x) => x?.taskId),
          } as unknown as Task),
      ) ?? [],
    [_tasks],
  );

  return tasks;
};

export const useTasksByProjectId = (projectId: number): Task[] => {
  const getTaskObjects = useMemo(getTasksByProjectId, []);

  return useSelector((state: RootState) => getTaskObjects(state, projectId));
};
